export default "__VITE_ASSET__CNIEl$1$__"